"use client";
import React, { useState, useEffect } from "react";

export default function AllPostsPost({ posts }) {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const loadMorePosts = async () => {
  };

  return (
    <div className="all-blog-posts">
      {posts.length > 0
        ? posts.map((post, index) => (
          <div key={index} className="all-blog-posts-post">
            <div className="all-blog-posts-post-image">
              <img
                src={post.attributes.main_image.data.attributes.url}
                alt={post.attributes.title}
              />
            </div>
            <div className="all-blog-posts-post-details">
              <div className="all-blog-posts-heading-details">
                <h1>{post.attributes.title}</h1>
                <h5>{post.attributes.date}</h5>
              </div>
              <div className="all-blog-posts-content">
                <p>{post.attributes.card_description}</p>
              </div>
            </div>
          </div>
        ))
        : "No posts found."}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <button onClick={loadMorePosts}>Load More Posts</button>
      )}
    </div>
  );
}
